import { const_var, params } from "../../../redux/reducers/reducer";
import * as cuBuilding from "../../../redux/reducers/building_pricing/pricingReducer";
import * as utils from "../../../redux/reducers/utils";
import { LEAN_TYPE_NUM_TO_STR } from "../../../Constants/constant";
import leanToWallOptionHelpers from "../lenatoWallOptions.helpers";
import { updateWallSelection } from "../../building_pricing/wall_pricing/wallPricing.helper";
export const changeLeanStyle = (state, action) => {
	const_var.post_data?.building?.leanto?.forEach((l) => {
		if (LEAN_TYPE_NUM_TO_STR[l.leanto_type] === action.leanType) {
			l.leanto_style = action.leanStyle;
		}
	});

	if (Array.isArray(const_var.post_data?.building?.leanto)) {
		state.const_var.post_data.building.leanto = const_var.post_data.building.leanto;
	}

	state.params.leanStyle[action.leanType] = action.leanStyle;

	if (action.leanStyle == "gable") {
		const_var.isLTBuilding = true;

		const theAvailableStandardLeanto = ["left", "right", "front", "back"]
			.filter((value) => value !== action.leanType)
			.find((value) => {
				return params.leanStyle[value] === "standard";
			});
		if (theAvailableStandardLeanto) {
			const_var.navEventKey.leanto = `${theAvailableStandardLeanto}Lean`;
		}
	} else if (action.leanStyle === "standard") {
		let stillHasAtLeastOneGable = false;
		["right", "left", "front", "back"].forEach((l) => {
			if (params.leanStyle[l] == "gable") {
				stillHasAtLeastOneGable = true;
			}
		});

		if (!stillHasAtLeastOneGable) {
			const_var.isLTBuilding = false;
		}
	}

	leanToWallOptionHelpers.refreshLeanToWalls(state, action);

	return { ...state, action };
};
export const updateLeanUtilityPosition = (state, action) => {
	if (action.name === "front") {
		state.params.leanF_p_pos = action.position;
	} else if (action.name === "back") {
		state.params.leanB_p_pos = action.position;
	} else if (action.name === "left") {
		state.params.lean_p_pos = action.position;
	} else if (action.name === "right") {
		state.params.leanR_p_pos = action.position;
	}

	return {
		...state,
		action
	};
};
export const updateLeftLeanUtilityPosition = (state, action) => {
	const_var.UpdatedPriceData.wainscot_price_changed = true;
	const startPosition = action.isDrag !== undefined ? action.startPosition : params.leftLeanStoragePosition;
	state.params.leftLeanStoragePosition = action.positionZ;
	if (params.leanStyle.left === "gable" && params.p_l_w === "Close") {
		state.params.p_b_c_b_l_b = "Open";
	} else if (params.leftLeanStoragePosition === 0 && startPosition != 0 && params.p_l_w != "Close" && params.leanStyle.left === "gable") {
		if (action.isDrag != undefined && action.isDrag == true) state.params.prev_p_b_c_b_l_b = state.params.p_b_c_b_l_b;
		state.params.p_b_c_b_l_b = "Close";
	} else if (params.leftLeanStoragePosition === 0 && startPosition != 0 && params.p_b_c_b_l_b != "Close" && params.leanStyle.left === "standard") {
		if (action.isDrag != undefined && action.isDrag == true) state.params.prev_p_b_c_b_l_b = state.params.p_b_c_b_l_b;
		state.params.p_b_c_b_l_b = "Close";
	} else if (startPosition === 0 && params.leftLeanStoragePosition !== 0 && params.p_b_c_b_l_b === "Close") {
		if (action.isDrag != undefined && state.params.prev_p_b_c_b_l_b != undefined && action.isDrag == true) {
			state.params.p_b_c_b_l_b = state.params.prev_p_b_c_b_l_b;
		} else {
			state.params.p_b_c_b_l_b = "Open";
		}
	}

	if (params.leftLeanStoragePosition === params.lean_p_d - parseInt(params.add_storage) && startPosition != params.lean_p_d - parseInt(params.add_storage)) {
		if (action.isDrag != undefined && action.isDrag == true) state.params.prev_p_b_c_b_l_f = state.params.p_b_c_b_l_f;
		state.params.p_b_c_b_l_f = "Close";
	} else if (startPosition === params.lean_p_d - parseInt(params.add_storage) && params.leftLeanStoragePosition !== params.lean_p_d - parseInt(params.add_storage) && params.p_b_c_b_l_f === "Close") {
		if (action.isDrag != undefined && state.params.prev_p_b_c_b_l_f != undefined && action.isDrag == true) {
			state.params.p_b_c_b_l_f = state.params.prev_p_b_c_b_l_f;
		} else {
			state.params.p_b_c_b_l_f = "Open";
		}
	} else if (params.leftLeanStoragePosition === params.lean_p_d - parseInt(params.add_storage) && action.isDrag === false) {
		state.params.p_b_c_b_l_f = "Close";
	}

	const leanData = const_var.post_data?.building?.leanto?.find((e) => e.leanto_type === 1);
	if (leanData) leanData.utility_position = params.leftLeanStoragePosition;

	cuBuilding.UpdateLeftLean();
	updateWallSelection();
	if (
		(state.params.leftLeanStoragePosition == 0 ||
			startPosition == 0 ||
			state.params.leftLeanStoragePosition == state.params.lean_p_d - parseInt(state.params.add_storage) ||
			startPosition == state.params.lean_p_d - parseInt(state.params.add_storage)) &&
		state.const_var.leanGetDataLeft
	) {
		if (const_var.onDragUtilityPriceUpdateLeft != true) {
			const_var.UpdatedPriceData.left_lean_insulation_price_changed = true;
			const_var.UpdatedPriceData.insulation_price_changed = true;
			state.const_var.UpdatedPriceData.left_lean_front_wall_price_changed = true;
			state.const_var.UpdatedPriceData.left_lean_back_wall_price_changed = true;
			state.const_var.UpdatedPriceData.left_lean_utility_price_changed = true;
		}
		cuBuilding.cPforLLeanOnly(state.const_var.leanGetDataLeft);
	}

	return {
		...state,
		newColor: action
	};
};
export const updateRightLeanUtilityPosition = (state, action) => {
	const_var.UpdatedPriceData.wainscot_price_changed = true;
	const startPosition = action.isDrag !== undefined ? action.startPosition : params.rightLeanStoragePosition;
	state.params.rightLeanStoragePosition = action.positionZ;
	if (params.leanStyle.right === "gable" && params.p_r_w === "Close") {
		state.params.p_b_c_b_r_b = "Open";
	} else if (params.rightLeanStoragePosition === 0 && startPosition != 0 && params.p_r_w != "Close" && params.leanStyle.right === "gable") {
		if (action.isDrag != undefined && action.isDrag == true) state.params.prev_p_b_c_b_r_b = state.params.p_b_c_b_r_b;
		state.params.p_b_c_b_r_b = "Close";
	} else if (params.rightLeanStoragePosition === 0 && startPosition != 0 && params.prev_p_b_c_b_r_b != "Close" && params.leanStyle.right === "standard") {
		if (action.isDrag != undefined && action.isDrag == true) state.params.prev_p_b_c_b_r_b = state.params.p_b_c_b_r_b;
		state.params.p_b_c_b_r_b = "Close";
	} else if (startPosition === 0 && params.rightLeanStoragePosition !== 0 && params.p_b_c_b_r_b === "Close") {
		if (action.isDrag != undefined && state.params.prev_p_b_c_b_r_b != undefined && action.isDrag == true) {
			state.params.p_b_c_b_r_b = state.params.prev_p_b_c_b_r_b;
		} else {
			state.params.p_b_c_b_r_b = "Open";
		}
	}

	if (params.rightLeanStoragePosition === params.leanR_p_d - parseInt(params.add_storage_right) && startPosition != params.leanR_p_d - parseInt(params.add_storage_right)) {
		if (action.isDrag != undefined && action.isDrag == true) state.params.prev_p_b_c_b_r_f = state.params.p_b_c_b_r_f;
		state.params.p_b_c_b_r_f = "Close";
	} else if (startPosition === params.leanR_p_d - parseInt(params.add_storage_right) && params.rightLeanStoragePosition !== params.leanR_p_d - parseInt(params.add_storage_right) && params.p_b_c_b_r_f === "Close") {
		if (action.isDrag != undefined && state.params.prev_p_b_c_b_r_f != undefined && action.isDrag == true) {
			state.params.p_b_c_b_r_f = state.params.prev_p_b_c_b_r_f;
		} else {
			state.params.p_b_c_b_r_f = "Open";
		}
	} else if (params.rightLeanStoragePosition === params.leanR_p_d - parseInt(params.add_storage_right) && action.isDrag === false) {
		state.params.p_b_c_b_r_f = "Close";
	}
	const leanData = const_var.post_data?.building?.leanto?.find((e) => e.leanto_type === 2);
	if (leanData) leanData.utility_position = params.rightLeanStoragePosition;

	cuBuilding.UpdateRightLean();
	updateWallSelection();
	if (
		(state.params.rightLeanStoragePosition == 0 ||
			startPosition == 0 ||
			state.params.rightLeanStoragePosition == state.params.leanR_p_d - parseInt(state.params.add_storage_right) ||
			startPosition == state.params.leanR_p_d - parseInt(state.params.add_storage_right)) &&
		state.const_var.leanGetDataRight
	) {
		if (const_var.onDragUtilityPriceUpdateRight != true) {
			const_var.UpdatedPriceData.right_lean_insulation_price_changed = true;
			const_var.UpdatedPriceData.insulation_price_changed = true;
			state.const_var.UpdatedPriceData.right_lean_front_wall_price_changed = true;
			state.const_var.UpdatedPriceData.right_lean_back_wall_price_changed = true;
			state.const_var.UpdatedPriceData.right_lean_utility_price_changed = true;
		}
		cuBuilding.cPforRLeanOnly(state.const_var.leanGetDataRight);
	}

	return {
		...state,
		newColor: action
	};
};
export const updateFrontLeanUtilityPosition = (state, action) => {
	const_var.UpdatedPriceData.wainscot_price_changed = true;
	const startPosition = action.isDrag !== undefined ? action.startPosition : params.frontLeanStoragePosition;
	state.params.frontLeanStoragePosition = action.positionX;
	if (params.leanStyle.front === "standard") {
		if (params.frontLeanStoragePosition <= 0 && startPosition > 0) {
			if (action.isDrag != undefined && action.isDrag == true) state.params.prev_p_b_c_b_f_b = state.params.p_b_c_b_f_b;
			state.params.p_b_c_b_f_b = "Close";
		} else if (startPosition <= 0 && params.frontLeanStoragePosition > 0 && params.p_b_c_b_f_b === "Close") {
			if (action.isDrag != undefined && state.params.prev_p_b_c_b_f_b != undefined && action.isDrag == true) {
				state.params.p_b_c_b_f_b = state.params.prev_p_b_c_b_f_b;
			} else {
				state.params.p_b_c_b_f_b = "Open";
			}
		}

		if (params.frontLeanStoragePosition === params.leanF_p_d - parseInt(params.add_storage_front) - 0.2 && startPosition != params.leanF_p_d - parseInt(params.add_storage_front) - 0.2) {
			if (action.isDrag != undefined && action.isDrag == true) state.params.prev_p_b_c_b_f_f = state.params.p_b_c_b_f_f;
			state.params.p_b_c_b_f_f = "Close";
		} else if (
			startPosition === params.leanF_p_d - parseInt(params.add_storage_front) - 0.2 &&
			params.frontLeanStoragePosition !== params.leanF_p_d - parseInt(params.add_storage_front) - 0.2 &&
			params.p_b_c_b_f_f === "Close"
		) {
			if (action.isDrag != undefined && state.params.prev_p_b_c_b_f_f != undefined && action.isDrag == true) {
				state.params.p_b_c_b_f_f = state.params.prev_p_b_c_b_f_f;
			} else {
				state.params.p_b_c_b_f_f = "Open";
			}
		}
	} else {
		if (params.p_f_w === "Close") {
			state.params.p_b_c_b_f_b = "Open";
		} else if (params.frontLeanStoragePosition === 0 && params.p_f_w !== "Close") {
			state.params.p_b_c_b_f_b = "Close";
		} else if (params.frontLeanStoragePosition === 0 && startPosition !== 0) {
			if (action.isDrag != undefined && action.isDrag == true) state.params.prev_p_b_c_b_f_b = state.params.p_b_c_b_f_b;
			const is_GableLeanBackWall = state.params.leanStyle.front !== "gable" || (state.params.leanStyle.front === "gable" && state.params.p_f_w !== "Close");
			if (is_GableLeanBackWall) {
				state.params.p_b_c_b_f_b = "Close";
			}
		} else if (startPosition === 0 && params.frontLeanStoragePosition !== 0 && params.p_b_c_b_f_b === "Close") {
			if (action.isDrag != undefined && state.params.prev_p_b_c_b_f_b != undefined && action.isDrag == true) {
				state.params.p_b_c_b_f_b = state.params.prev_p_b_c_b_f_b;
			} else {
				state.params.p_b_c_b_f_b = "Open";
			}
		}

		if (params.frontLeanStoragePosition === params.leanF_p_d - parseInt(params.add_storage_front) && startPosition !== params.leanF_p_d - parseInt(params.add_storage_front)) {
			if (action.isDrag != undefined && action.isDrag == true) state.params.prev_p_b_c_b_f_f = state.params.p_b_c_b_f_f;
			state.params.p_b_c_b_f_f = "Close";
		} else if (startPosition === params.leanF_p_d - parseInt(params.add_storage_front) && params.frontLeanStoragePosition !== params.leanF_p_d - parseInt(params.add_storage_front) && params.p_b_c_b_f_f === "Close") {
			if (action.isDrag != undefined && state.params.prev_p_b_c_b_f_f != undefined && action.isDrag == true) {
				state.params.p_b_c_b_f_f = state.params.prev_p_b_c_b_f_f;
			} else {
				state.params.p_b_c_b_f_f = "Open";
			}
		}
	}
	const leanData = const_var.post_data?.building?.leanto?.find((e) => e.leanto_type === 3);
	if (leanData) leanData.utility_position = params.frontLeanStoragePosition;

	cuBuilding.UpdateFrontLean();
	updateWallSelection();
	if (
		Number(state.params.frontLeanStoragePosition?.toFixed(5)) == 0 ||
		Number(startPosition?.toFixed(5)) == 0 ||
		Number(state.params.frontLeanStoragePosition?.toFixed(5)) == state.params.leanF_p_d - parseInt(state.params.add_storage_front) ||
		Number(startPosition?.toFixed(5)) == state.params.leanF_p_d - parseInt(state.params.add_storage_front)
	) {
		if (const_var.onDragUtilityPriceUpdateFront != true) {
			const_var.UpdatedPriceData.front_lean_insulation_price_changed = true;
			const_var.UpdatedPriceData.insulation_price_changed = true;
			state.const_var.UpdatedPriceData.front_lean_front_wall_price_changed = true;
			state.const_var.UpdatedPriceData.front_lean_back_wall_price_changed = true;
			state.const_var.UpdatedPriceData.front_lean_utility_price_changed = true;
		}
		cuBuilding.cPforFLeanOnly(state.const_var.leanGetDataFront);
	}

	return {
		...state,
		newColor: action
	};
};
export const updateBackLeanUtilityPosition = (state, action) => {
	const_var.UpdatedPriceData.wainscot_price_changed = true;
	const startPosition = action.isDrag !== undefined ? action.startPosition : params.backLeanStoragePosition;
	state.params.backLeanStoragePosition = action.positionX;
	if (params.leanStyle.back === "standard") {
		if (params.backLeanStoragePosition <= 0 && startPosition > 0) {
			if (action.isDrag != undefined && action.isDrag == true) state.params.prev_p_b_c_b_b_b = state.params.p_b_c_b_b_b;
			state.params.p_b_c_b_b_b = "Close";
		} else if (startPosition <= 0 && params.backLeanStoragePosition > 0 && params.p_b_c_b_b_b === "Close") {
			if (action.isDrag != undefined && state.params.prev_p_b_c_b_b_b != undefined && action.isDrag == true) {
				state.params.p_b_c_b_b_b = state.params.prev_p_b_c_b_b_b;
			} else {
				state.params.p_b_c_b_b_b = "Open";
			}
		}

		if (params.backLeanStoragePosition === params.leanB_p_d - parseInt(params.add_storage_back) - 0.2 && startPosition != params.leanB_p_d - parseInt(params.add_storage_back) - 0.2) {
			if (action.isDrag != undefined && action.isDrag == true) state.params.prev_p_b_c_b_b_f = state.params.p_b_c_b_b_f;
			state.params.p_b_c_b_b_f = "Close";
		} else if (
			startPosition === params.leanB_p_d - parseInt(params.add_storage_back) - 0.2 &&
			params.backLeanStoragePosition !== params.leanB_p_d - parseInt(params.add_storage_back) - 0.2 &&
			params.p_b_c_b_b_f === "Close"
		) {
			if (action.isDrag != undefined && state.params.prev_p_b_c_b_b_f != undefined && action.isDrag == true) {
				state.params.p_b_c_b_b_f = state.params.prev_p_b_c_b_b_f;
			} else {
				state.params.p_b_c_b_b_f = "Open";
			}
		}
	} else {
		if (params.p_b_w === "Close") {
			state.params.p_b_c_b_b_b = "Open";
		} else if (params.backLeanStoragePosition === 0 && params.p_b_w !== "Close") {
			state.params.p_b_c_b_b_b = "Close";
		} else if (params.backLeanStoragePosition === 0 && startPosition !== 0) {
			if (action.isDrag != undefined && action.isDrag == true) state.params.prev_p_b_c_b_b_b = state.params.p_b_c_b_b_b;
			let is_GableLeanBackWall = state.params.leanStyle.back !== "gable" || (state.params.leanStyle.back === "gable" && state.params.p_b_w !== "Close");
			if (is_GableLeanBackWall) {
				state.params.p_b_c_b_b_b = "Close";
			}
		} else if (startPosition === 0 && params.backLeanStoragePosition !== 0 && params.p_b_c_b_b_b === "Close") {
			if (action.isDrag != undefined && state.params.prev_p_b_c_b_b_b != undefined && action.isDrag == true) {
				state.params.p_b_c_b_b_b = state.params.prev_p_b_c_b_b_b;
			} else {
				state.params.p_b_c_b_b_b = "Open";
			}
		}

		if (params.backLeanStoragePosition === params.leanB_p_d - parseInt(params.add_storage_back) && startPosition !== params.leanB_p_d - parseInt(params.add_storage_back)) {
			if (action.isDrag != undefined && action.isDrag == true) state.params.prev_p_b_c_b_b_f = state.params.p_b_c_b_b_f;
			state.params.p_b_c_b_b_f = "Close";
		} else if (startPosition === params.leanB_p_d - parseInt(params.add_storage_back) && params.backLeanStoragePosition !== params.leanB_p_d - parseInt(params.add_storage_back) && params.p_b_c_b_b_f === "Close") {
			if (action.isDrag != undefined && state.params.prev_p_b_c_b_b_f != undefined && action.isDrag == true) {
				state.params.p_b_c_b_b_f = state.params.prev_p_b_c_b_b_f;
			} else {
				state.params.p_b_c_b_b_f = "Open";
			}
		}
	}

	const leanData = const_var.post_data?.building?.leanto?.find((e) => e.leanto_type === 4);
	if (leanData) leanData.utility_position = params.backLeanStoragePosition;

	cuBuilding.UpdateBackLean();
	updateWallSelection();
	if (
		Number(state.params.backLeanStoragePosition?.toFixed(5)) == 0 ||
		Number(startPosition?.toFixed(5)) == 0 ||
		Number(state.params.backLeanStoragePosition?.toFixed(5)) == state.params.leanB_p_d - parseInt(state.params.add_storage_back) ||
		Number(startPosition?.toFixed(5)) == state.params.leanB_p_d - parseInt(state.params.add_storage_back)
	) {
		if (const_var.onDragUtilityPriceUpdateBack != true) {
			const_var.UpdatedPriceData.back_lean_insulation_price_changed = true;
			const_var.UpdatedPriceData.insulation_price_changed = true;
			state.const_var.UpdatedPriceData.back_lean_front_wall_price_changed = true;
			state.const_var.UpdatedPriceData.back_lean_back_wall_price_changed = true;
			state.const_var.UpdatedPriceData.back_lean_utility_price_changed = true;
		}
		cuBuilding.cPforBLeanOnly(state.const_var.leanGetDataBack);
	}

	return {
		...state,
		newColor: action
	};
};
export const updateEndStoragePositionZ = (state, action) => {
	state.params.endStoragePositionZ = action.positionZ;
	if (params.endStoragePositionZ === 0 && action.startPositionZ != 0) {
		if (action.isDrag != undefined && action.isDrag == true) state.params.prev_p_b_w = state.params.p_b_w;
		state.params.p_b_w = "Close";
		utils.wallSelectionChangesForLNTBuilding(state, "back", true);
	} else if (action.startPositionZ === 0 && params.endStoragePositionZ !== 0 && params.p_b_w === "Close") {
		if (action.isDrag != undefined && state.params.prev_p_b_w != undefined && action.isDrag == true) {
			state.params.p_b_w = state.params.prev_p_b_w;
		} else {
			state.params.p_b_w = "Open";
		}
	}

	if (params.endStoragePositionZ === params.p_d - parseInt(params.p_u_t) && action.startPositionZ != params.p_d - parseInt(params.p_u_t)) {
		if (action.isDrag != undefined && action.isDrag == true) state.params.prev_p_f_w = state.params.p_f_w;
		state.params.p_f_w = "Close";
		utils.wallSelectionChangesForLNTBuilding(state, "front", true);
	} else if (action.startPositionZ === params.p_d - parseInt(params.p_u_t) && params.endStoragePositionZ !== params.p_d - parseInt(params.p_u_t) && params.p_f_w === "Close") {
		if (action.isDrag != undefined && state.params.prev_p_f_w != undefined && action.isDrag == true) {
			state.params.p_f_w = state.params.prev_p_f_w;
		} else {
			state.params.p_f_w = "Open";
		}
	}

	if (state.params.p_b_w != "Close" || state.params.p_f_w != "Close" || state.params.p_l_w != "Close" || state.params.p_r_w != "Close") {
		state.isFullyEnclosedChecked = false;
	} else {
		state.isFullyEnclosedChecked = true;
	}

	if (state.const_var.post_data) state.const_var.post_data.building.utility_position = state.params.endStoragePositionZ;

	cuBuilding.BuildingUpdate(true, "");
	updateWallSelection();

	if (action.startPositionZ == 0 || state.params.endStoragePositionZ == 0 || state.params.endStoragePositionZ == params.p_d - parseInt(params.p_u_t) || action.startPositionZ == params.p_d - parseInt(params.p_u_t)) {
		state.const_var.UpdatedPriceData.front_wall_price_changed = true;
		state.const_var.UpdatedPriceData.back_wall_price_changed = true;
		const_var.UpdatedPriceData.utility_price_changed = true;
		const_var.UpdatedPriceData.wainscot_price_changed = true;
		cuBuilding.cP();
	}

	return {
		...state,
		newColor: action
	};
};
export const chnageLeanToPosition = (state, action, cuComponent) => {
	if (action.value == "left") {
		params.leantoAlignmentLeft = action.event;
		if (state.params.add_left_front_lean_porch != false && params.leantoAlignmentLeft != "2") {
			state.params.add_left_front_lean_porch = false;
		}

		if (state.params.add_left_back_lean_porch != false && params.leantoAlignmentLeft != "3") {
			state.params.add_left_back_lean_porch = false;
		}

		let lstPos = 0;
		let currPos = 0;

		if (params.leantoAlignmentLeft == "1") state.params.lean_p_pos = 0;
		else if (params.leantoAlignmentLeft == "2") state.params.lean_p_pos = params.p_d / 2 - (state.params.leanStyle.left === "standard" ? params.lean_p_d / 2 : params.lean_p_w / 2);
		else if (params.leantoAlignmentLeft == "3") state.params.lean_p_pos = -params.p_d / 2 + (state.params.leanStyle.left === "standard" ? params.lean_p_d / 2 : params.lean_p_w / 2);

		currPos = state.params.lean_p_pos;
		if (lstPos != currPos) {
			const diff = currPos - lstPos;
			const_var.entry_points.forEach((e) => {
				if (e.component_wall_name == "L_L_L_W" || e.component_wall_name == "L_L_L_S_W" || e.component_wall_name == "L_L_R_S_W") e.entry_position.z += diff;
			});
		}
	}
	if (action.value == "right") {
		params.leantoAlignmentRight = action.event;

		if (state.params.add_right_front_lean_porch != false && params.leantoAlignmentRight != "2") {
			state.params.add_right_front_lean_porch = false;
		}

		if (state.params.add_right_back_lean_porch != false && params.leantoAlignmentRight != "3") {
			state.params.add_right_back_lean_porch = false;
		}

		let lstPos = 0;
		let currPos = 0;

		if (params.leantoAlignmentRight == "1") state.params.leanR_p_pos = 0;
		else if (params.leantoAlignmentRight == "2") state.params.leanR_p_pos = params.p_d / 2 - (state.params.leanStyle.right === "standard" ? params.leanR_p_d / 2 : params.leanR_p_w / 2);
		else if (params.leantoAlignmentRight == "3") state.params.leanR_p_pos = -params.p_d / 2 + (state.params.leanStyle.right === "standard" ? params.leanR_p_d / 2 : params.leanR_p_w / 2);

		currPos = state.params.leanR_p_pos;
		if (lstPos != currPos) {
			const diff = currPos - lstPos;
			const_var.entry_points.forEach((e) => {
				if (e.component_wall_name == "R_L_R_W" || e.component_wall_name == "R_L_R_S_W" || e.component_wall_name == "R_L_L_S_W") e.entry_position.z += diff;
			});
		}
	}
	if (action.value == "front") {
		params.leantoAlignmentFront = action.event;

		if (state.params.add_right_front_lean_porch != false && params.leantoAlignmentFront != "3") {
			state.params.add_right_front_lean_porch = false;
		}

		if (state.params.add_left_front_lean_porch != false && params.leantoAlignmentFront != "2") {
			state.params.add_left_front_lean_porch = false;
		}

		let lstPos = 0;
		let currPos = 0;

		if (params.leantoAlignmentFront == "1") state.params.leanF_p_pos = 0;
		if (params.leantoAlignmentFront == "3") state.params.leanF_p_pos = params.p_w / 2 - (state.params.leanStyle.front === "standard" ? params.leanF_p_d / 2 : params.leanF_p_w / 2);
		if (params.leantoAlignmentFront == "2") state.params.leanF_p_pos = -params.p_w / 2 + (state.params.leanStyle.front === "standard" ? params.leanF_p_d / 2 : params.leanF_p_w / 2);

		currPos = state.params.leanF_p_pos;
		if (lstPos != currPos) {
			const diff = currPos - lstPos;
			const_var.entry_points.forEach((e) => {
				if (e.component_wall_name == "F_L_F_W" || e.component_wall_name == "F_L_F_S_W") e.entry_position.x += diff;
			});
		}

		if (params.add_left_front_lean_porch == true) cuBuilding.UpdateLeftLean();
	}
	if (action.value == "back") {
		params.leantoAlignmentBack = action.event;

		if (state.params.add_right_back_lean_porch != false && params.leantoAlignmentBack != "2") {
			state.params.add_right_back_lean_porch = false;
		}

		if (state.params.add_left_back_lean_porch != false && params.leantoAlignmentBack != "3") {
			state.params.add_left_back_lean_porch = false;
		}

		let lstPos = 0;
		let currPos = 0;
		if (params.leantoAlignmentBack == "1") state.params.leanB_p_pos = 0;
		if (params.leantoAlignmentBack == "2") state.params.leanB_p_pos = params.p_w / 2 - (state.params.leanStyle.back === "standard" ? params.leanB_p_d / 2 : params.leanB_p_w / 2);
		if (params.leantoAlignmentBack == "3") state.params.leanB_p_pos = -params.p_w / 2 + (state.params.leanStyle.back === "standard" ? params.leanB_p_d / 2 : params.leanB_p_w / 2);

		currPos = state.params.leanB_p_pos;
		if (lstPos != currPos) {
			const diff = currPos - lstPos;
			const_var.entry_points.forEach((e) => {
				if (e.component_wall_name == "B_L_S_W" || e.component_wall_name == "B_L_F_S_W") e.entry_position.x += diff;
			});
		}
	}
	cuBuilding.cP();

	cuComponent.RemovePorchComponent();

	return {
		...state,
		newColor: action.event + action.value
	};
};
export const checkChangeLeantoPosition = (state, action) => {
	if (action.value == "left") {
		if (params.add_left_front_lean_porch != false && action.event != "2") {
			const_var.isShowAlert = true;
			const_var.alertUsedFor = "YourCanNotAlignPorch";
		}

		if (params.add_left_back_lean_porch != false && action.event != "3") {
			const_var.isShowAlert = true;
			const_var.alertUsedFor = "YourCanNotAlignPorch";
		}
	}

	if (action.value == "right") {
		if (params.add_right_front_lean_porch != false && action.event != "2") {
			const_var.isShowAlert = true;
			const_var.alertUsedFor = "YourCanNotAlignPorch";
		}

		if (params.add_right_back_lean_porch != false && action.event != "3") {
			const_var.isShowAlert = true;
			const_var.alertUsedFor = "YourCanNotAlignPorch";
		}
	}

	if (action.value == "front") {
		if (params.add_right_front_lean_porch != false && action.event != "3") {
			const_var.isShowAlert = true;
			const_var.alertUsedFor = "YourCanNotAlignPorch";
		}

		if (params.add_left_front_lean_porch != false && action.event != "2") {
			const_var.isShowAlert = true;
			const_var.alertUsedFor = "YourCanNotAlignPorch";
		}
	}

	if (action.value == "back") {
		if (params.add_right_back_lean_porch != false && action.event != "2") {
			const_var.isShowAlert = true;
			const_var.alertUsedFor = "YourCanNotAlignPorch";
		}

		if (params.add_left_back_lean_porch != false && action.event != "3") {
			const_var.isShowAlert = true;
			const_var.alertUsedFor = "YourCanNotAlignPorch";
		}
	}

	return {
		...state,
		action
	};
};
